const PROD_MOS_REGEX = /\[(?:PROD|MOS)\][\s\S]*?\[\/(?:PROD|MOS)\]/g;
const HTML_TAGS_REGEX = /<[^>]+>/gi;

const extractCommands = (text: string): string[] => {
    return text.match(PROD_MOS_REGEX) ?? [];
};

const extractPlainText = (text: string): string => {
    return text
        .replace(PROD_MOS_REGEX, '')
        .replace(HTML_TAGS_REGEX, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\u00A0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

const normalizeCommand = (command: string): string => {
    return command
        .replace(HTML_TAGS_REGEX, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\u00A0/g, ' ')
        .replace(/\[\/?(PROD|MOS)\]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};

export const isStoryTextEqual = (a: string, b: string): boolean => {
    if (!a && !b) return true;
    if (!a || !b) {
        const otherSide = a || b;
        if (!otherSide.trim()) return true;
        console.warn('[StoryTextCompare] One side is empty/null', { a: !!a, b: !!b });
        return false;
    }

    const plainA = extractPlainText(a);
    const plainB = extractPlainText(b);
    if (plainA !== plainB) {
        console.warn('[StoryTextCompare] Plain text differs', { plainA, plainB });
        return false;
    }

    const commandsA = extractCommands(a).map(normalizeCommand);
    const commandsB = extractCommands(b).map(normalizeCommand);

    if (commandsA.length !== commandsB.length) {
        console.warn('[StoryTextCompare] Command count differs', { countA: commandsA.length, countB: commandsB.length });
        return false;
    }

    const diffIndex = commandsA.findIndex((cmd, i) => cmd !== commandsB[i]);
    if (diffIndex !== -1) {
        console.warn('[StoryTextCompare] Command differs at index ' + diffIndex, { a: commandsA[diffIndex], b: commandsB[diffIndex] });
        return false;
    }

    return true;
};
